import React from "react";
import "../../People.css";
import "../../assets/css/people.css";
import studentData from "../../data/students.json";
import AlumniDropdown from "../AlumniDropdown";

const PGStudents = () => {
  const pgStudents = Object.entries(studentData.students).filter(
    ([key, students]) => key !== "PhD" && Array.isArray(students) && students.length > 0
  );

  return (
    <div className="people-container">
      {/* PG Students Section */}
      <div id="pg-students" className="students-section">
        <h1 className="section-heading">PG Students</h1>
        {pgStudents.map(([stream, students]) => (
          <div key={stream}>
            <AlumniDropdown title={stream} people={students} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PGStudents;
